// extracted by mini-css-extract-plugin
export default {"CustomInput":"Input_CustomInput__NOzSK","Input":"Input_Input__eviZv","InputArea":"Input_InputArea__9IUY4"};